import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { componentNeedsResolution } from '@angular/core/src/metadata/resource_loading';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';
import { CreateOrderProductComponent } from '../../create-orders/create-order-product/create-order-product.component';
import { ProductComponent } from '../../product/models/component';

import { Product, Products } from '../../product/models/product';
import { ProductService } from '../../product/product.service';
import { ServicesService } from '../../services/services.service';
import { OrderData } from '../models/order-data';

@Component({
  selector: 'app-single-order',
  templateUrl: './view-single-order.component.html',
  styleUrls: ['./view-single-order.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class SingleOrderComponent implements OnInit {
  @Input() orderData: OrderData;
  @Output() viewOrders: EventEmitter<void> = new EventEmitter<void>();

  @ViewChildren('createOrderComponent') createOrderComponents: QueryList<CreateOrderProductComponent>;

  order_arr = []

  allProducts: Products = [];
  orderProducts: Products = [];
  newProducts: Products = [];

  selectedProduct: Product;

  editRowId: any;

  select2ProductsConfig = {
    displayKey: "product_name", //if objects array passed which key to be displayed defaults to description,
    search: true, //enables the search plugin to search in the list,
  };

  spinLoader = {
    filter: false,
    delete: [],
  };

  get total(): number {
    let runningTotal = 0;
    if (!isNullOrUndefined(this.orderProducts) && this.orderProducts.length > 0) {
      const totalAmount = this.orderProducts.reduce((n, { amount, quantity }) => n + (amount * quantity), 0);
      runningTotal += totalAmount;
    }

    runningTotal += this.newProductTotal;

    return runningTotal;
  };

  get newProductTotal(): number {
    let runningTotal = 0;

    if (!isNullOrUndefined(this.newProducts) && this.newProducts.length > 0) {
      const totalAmount = this.newProducts.reduce((n, { amount, quantity }) => n + (amount * quantity), 0);
      runningTotal += totalAmount;
    }

    return runningTotal;
  }

  get totalTax(): number {
    return this.total * 0.15;
  };

  get newProductTotalTax(): number {
    return this.newProductTotal * 0.15;
  }

  get overallTotal(): number {
    return this.total + this.totalTax;
  }

  get newProductOverallTotal(): number {
    return this.newProductTotal + this.newProductTotalTax;
  }


  headerColumns: any[] = [
    {
      field: "component_name",
      title: "Component Name",
      width: "32%",
      code: true,
      sort: false,
    },
    {
      field: "quantity",
      title: "Quantity",
      width: "20%",
      code: false,
      sort: false,
    },
    {
      field: "delivered",
      title: "Delivered Quantity",
      width: "27%",
      code: false,
      sort: false,
    },
    {
      field: "total_delivered_quantity",
      title: "Outstanding ",
      // 'width': '18%',
      code: false,
      sort: true,
    },
  ];

  constructor(private readonly _services: ServicesService,
    private readonly productService: ProductService,
    private readonly router: Router) {

  }

  ngOnInit(): void {
    this.getOrderInfo();
  }

  public onProductChanged(event: { value: Products }): void {

    this.selectedProduct = event.value[0] || null;
  }

  public addProduct(): void {
    this.productService.getComponentList(this.selectedProduct.product_id).subscribe(components => {

      const newProduct = new Product(this.selectedProduct);
      newProduct.components_list = [...components];

      this.newProducts.push(newProduct);
    })
  }

  updateOrder() {

    if (!this.validateNewProducts()) {
      return;
    }

    if (this.newProducts.length > 0) {
      this.addBackOrder();
    } else {
      this.updateExistingOrder()
    }
  }

  private updateExistingOrder() {
    const routeData = "Update_order";
    let token = this._services.getToken();
    const data = {
      New_Products: false,
      New_Products_Arr: [],
      order_id: this.orderData.id,
      arr: this.order_arr
    }

    this._services.postRequest(data, routeData, token).subscribe((resp: any) => {
      swal({
        title: 'Success',
        text: 'The order has been updated successfully',
        type: 'success',
        showCancelButton: false,
        confirmButtonColor: "rgb(17, 205, 239)",
        cancelButtonColor: "rgb(245, 54, 92)",
        confirmButtonText: "Yes"
      });
    }, error => {
      swal({
        title: 'Error',
        text: 'The order could not be updated: ' + error.error.message,
        type: 'error',
        showCancelButton: false,
        confirmButtonColor: "rgb(17, 205, 239)",
        cancelButtonColor: "rgb(245, 54, 92)",
        confirmButtonText: "Yes"
      });
    })
  }

  private addBackOrder() {
    debugger;

    const orderDetails: any = {
      client_id: this.orderData.clientId,
      parent_order_id: this.orderData.id,
      order_no: this.generateOrderNumber(),
      order_date: new Date(Date.now()),
      project_order_id: this.orderData.project_order_id,
      product: this.newProducts.map(product => product.product_id),
      productData: this.newProducts.map(product => new Product({
        product_id: product.product_id,
        product_name: product.product_name,
        description: product.description,
        amount: product.amount,
        quantity: product.quantity,
        components_list: product.components_list.map((component: ProductComponent) => new ProductComponent({
          component_id: component.component_id,
          component_name: component.component_name,
          product_id: component.product_id,
          qty: component.qty
        }))
      })),
      total_amt: this.newProductOverallTotal,
      order_amt: this.newProductTotal,
    };

    this.fillProductDataWithUnneccesaryNullValues(orderDetails);

    //console.log("formdata", this.orderDetails);
    this._services.requestCreator(orderDetails, 'create-client-order-add-product', this._services.getToken()).subscribe((data: any) => {
      if (this._services.checkToken(data.status)) {
        if (data.status == '200') {
          //console.log("formdata", data);
          // this.isFormSubmitted=false;
          swal({
            title: 'Order Added Successfully',
            text: 'You Successfully Added Order',
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: 'rgb(17, 205, 239)',
            cancelButtonColor: 'rgb(245, 54, 92)',
            confirmButtonText: 'Yes'
          }).then(() => {
            this.router.navigateByUrl('/orders-list', {
              queryParams: {
                'cid': this.orderData.clientId,
                'cname': this.orderData.clientName
              }
            });
          })
        } else {
          // swal({
          //   title: 'Order Added Successfully',
          //   text: 'You Successfully Added Order',
          //   type: 'success',
          //   showCancelButton: false,
          //   confirmButtonColor: 'rgb(17, 205, 239)',
          //   cancelButtonColor: 'rgb(245, 54, 92)',
          //   confirmButtonText: 'Yes'
          // }).then(() => {
          //   this.orderDetails = {};
          //   this.showloader = true;
          //   this.router.navigateByUrl('/orders-list', { queryParams: { 'cid': this.cid } });
          // })
        }
      }
    });

  }

  private fillProductDataWithUnneccesaryNullValues(orderDetails: any): void {
    const result: Products = [];
    const numericIds = orderDetails.product.map(val => +val)
    const max = Math.max(...numericIds);

    for (let i = 0; i <= max; i++) {
      if (!orderDetails.product.includes(i)) {
        result.push(null);
      } else {
        result.push(orderDetails.productData.find(product => product.product_id === i));
      }
    }
    orderDetails.productData = result;
  }

  private generateOrderNumber(): string {
    let now = new Date();
    let currentMont = now.getMonth() + 1;
    let randomNumPart = Math.floor((Math.random() * 99)).toString().padStart(2, '0');

    return now.getDate() + '' + currentMont + '' + now.getFullYear() + '' + randomNumPart;
  }

  private validateNewProducts(): boolean {
    let result = true;
    this.createOrderComponents.forEach(comp => {
      if (!comp.markFormAsTouched()) {
        result = false;
      }
    });

    return result;
  }

  // TODO: This does not seem right, follow up on this.
  updateOrderElement(value) {

    if (this.order_arr.indexOf(value) < 0) {
      this.order_arr.push(value)
    } else {
      this.order_arr = this.order_arr.filter((ele: any) => {
        return value.component_id !== ele.component_id
      })
      this.order_arr.push(value)
    }

  }

  showOrderList() {
    this.viewOrders.emit();
  }

  toggle(id) {
    if (this.orderData.status !== "delivered") {
      this.editRowId = id;
    }
  }

  public removeEditingTemplate(event: KeyboardEvent): void {
    if (event && event.key) {
      switch (event.key) {
        case "Enter":
        case "Esc":
        case "Escape":
          this.editRowId = null; break;
      }
    }

    if (!event) {
      this.editRowId = null;
    }
  }

  removeProduct(product: Product): void {
    this.newProducts.splice(this.newProducts.indexOf(product), 1);
  }

  getOrderInfo() {
    this.spinLoader["filter"] = true;

    const requests$: Observable<any>[] = [
      this.productService.getAllProducts(),     // Get a list of all the products for the dropdown
      this.productService.getOrderProducts(this.orderData.id)  // Get a list of the products currently in the Order
    ]

    forkJoin(requests$).subscribe(results => {
      this.allProducts = results[0] as Products;
      const products = results[1]; // Dictionary format.

      this.orderProducts = [];

      products.forEach(product => {
        const productName = product[0].product_name;
        const quantity = product[0].product_qty;
        const amount = product[0].amount;


        let result = new Product(this.allProducts.find(p => p.product_name === productName));
        result.components_list = [...product];
        result.quantity = quantity;
        result.amount = amount;

        this.orderProducts.push(result)
      });

      this.spinLoader["filter"] = false;
    })
  }
}